import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@progress/kendo-react-buttons';
import eventEmitter from './utils/eventEmitter';
import './Tabs.scss';

/**
 * Tabs component
 * @module
 * @param {array} children - Children
 */
const TabsComponent = (props) => {
  const [state, setState] = useState({
    tab: 0
  });

  const handleChange = (name, value) => {
    setState((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleChangeTab = ({ name, tab }) => {
    if (!props.name || name === props.name) {
      setState((prevState) => ({
        ...prevState,
        tab
      }));
    }
  };

  useEffect(() => {
    eventEmitter.on('CHANGE_TAB', handleChangeTab);

    return () => {
      eventEmitter.removeAllListeners('CHANGE_TAB');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let tabs = props.children;

  return (
    <div className="card">
      <div className="card-header">
        {tabs.map((tabContent, index) => (
          <span key={index}>
            <Button
              primary={index === state.tab}
              onClick={() => handleChange('tab', index)}
            >
              {tabContent.props.title}
            </Button>
          </span>
        ))}
      </div>
      <div className="card-body">
        {tabs.map((tabContent, index) => (
          <div
            key={index}
            className={index === state.tab ? 'tab visible mt-3' : 'tab hidden'}
          >
            {tabContent}
          </div>
        ))}
      </div>
    </div>
  );
}

TabsComponent.propTypes = {
  children: PropTypes.array.isRequired
};

export default TabsComponent;
